/* CR98: confirmation that survives.
   Nielsen Norman's finding, twice over two research rounds: a confirmation that disappears makes people
   add the same thing again or lose confidence and leave. Dawn already opens the drawer and leaves it
   open, which is the first half. This file adds the two halves that were missing:
     1. the line that was just added is marked, so the shopper can see the SIZE they chose without
        hunting, which is the documented failure case;
     2. the product page button says "Added. Add another" for as long as that exact variant is in the
        cart, and reverts only when it is removed. A label that reverts on a timer is the same
        transient failure wearing a different hat.
   Progressive enhancement. If anything it needs is absent it does nothing and the page behaves as before.
   It never touches the checkout button and never blocks a submit. */
(() => {
  if (window.__nmAddConfirm) return;
  window.__nmAddConfirm = true;

  const TAG_MS = 8000;
  const ADDED_LABEL = 'Added. Add another';

  const lineFor = (id) => {
    if (!id) return null;
    const link = document.querySelector(`#CartDrawer a[href*="variant=${id}"], #main-cart-items a[href*="variant=${id}"]`);
    return link ? link.closest('.cart-item, tr, li') : null;
  };

  const markJustAdded = (id) => {
    const row = lineFor(id);
    if (!row) return;
    if (row.classList.contains('nm-just-added-row') || row.parentElement?.querySelector('.nm-just-added')) return;
    row.classList.add('nm-just-added-row');
    const tag = document.createElement('span');
    tag.className = 'nm-just-added';
    tag.textContent = 'Just added';
    // Announced once, politely: a shopper using a screen reader gets the same confirmation the
    // sighted one gets from the accent rule.
    tag.setAttribute('role', 'status');
    (row.querySelector('.cart-item__name') || row.firstElementChild || row).after(tag);
    setTimeout(() => { tag.classList.add('is-fading'); }, TAG_MS);
    setTimeout(() => { tag.remove(); row.classList.remove('nm-just-added-row'); }, TAG_MS + 600);
  };

  // Which variants are in the cart right now, read from Shopify rather than remembered, so a cart
  // emptied in another tab does not leave a button lying.
  let inCart = new Set();
  const readCart = async () => {
    try {
      const r = await fetch(`${window.routes ? window.routes.cart_url : '/cart'}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const c = await r.json();
      inCart = new Set((c.items || []).map((i) => String(i.variant_id)));
      paintButtons();
    } catch (e) { /* a cart we cannot read leaves the buttons alone */ }
  };

  const buttonsOnPage = () => [...document.querySelectorAll('form[action*="/cart/add"] [name="add"]')];

  const paintButtons = () => {
    for (const btn of buttonsOnPage()) {
      const form = btn.closest('form');
      const idInput = form && form.querySelector('[name="id"]');
      const id = idInput ? String(idInput.value) : null;
      const label = btn.querySelector('span') || btn;
      if (!id) continue;
      if (!btn.dataset.nmLabel) btn.dataset.nmLabel = label.textContent.trim();
      if (btn.disabled && !inCart.has(id)) continue;          // sold out, or no size chosen yet
      label.textContent = inCart.has(id) ? ADDED_LABEL : btn.dataset.nmLabel;
      btn.classList.toggle('nm-btn--added', inCart.has(id));
    }
  };

  // Dawn publishes a cart update with the variant that caused it; our own cross-sell forms publish the
  // same event. Fall back to watching the drawer for stores where the event never fires.
  const onUpdate = (payload) => {
    const id = payload && (payload.productVariantId || (payload.cartData && payload.cartData.variant_id));
    // The drawer replaces its own innerHTML when it re-renders, and the update event can arrive either
    // side of that swap, so a mark applied once is sometimes wiped a moment later. Try a few times
    // across the swap and stop as soon as it sticks.
    if (id) [120, 500, 1100, 2000].forEach((t) => setTimeout(() => markJustAdded(String(id)), t));
    readCart();
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onUpdate);
  } else {
    const drawer = document.querySelector('#CartDrawer');
    if (drawer) new MutationObserver(() => readCart()).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('change', (e) => { if (e.target.name === 'id' || e.target.closest('variant-selects')) setTimeout(paintButtons, 60); });
  document.addEventListener('DOMContentLoaded', readCart);
  if (document.readyState !== 'loading') readCart();
})();
